// AppId di piattaforma: sorgente di verità unica in `@neworg-net/amsuite-core/apps`
// (`AMSUITE_APP_IDS`). Qui restano solo la VIEW locale (chiavi storiche usate dai
// consumer di amsuite) mappata sul registry condiviso + `guid.empty` (anch'esso dal
// core). `widgets` è specifico di amsuite e resta locale.
import { AMSUITE_APP_IDS, AMSUITE_EMPTY_GUID } from '@neworg-net/amsuite-core/apps';

const apps = {
  adminPanel: AMSUITE_APP_IDS.adminPanel,
  amSuite: AMSUITE_APP_IDS.amsuite,
  employeeArchive: AMSUITE_APP_IDS.employeeArchive,
  crm: AMSUITE_APP_IDS.crm,
  calendar: AMSUITE_APP_IDS.calendar,
  dialog: AMSUITE_APP_IDS.dialog,
  attendanceSheet: AMSUITE_APP_IDS.attendanceSheet,
  causalRequest: AMSUITE_APP_IDS.causalRequest,
  clocking: AMSUITE_APP_IDS.clocking,
  partySharedArchive: AMSUITE_APP_IDS.partySharedArchive,
  partyProfile: AMSUITE_APP_IDS.partyProfile,
  refundedCosts: AMSUITE_APP_IDS.refundedCosts,
  comunica: AMSUITE_APP_IDS.comunica,
}

const widgets = {
  partyClockings: 'A5E62C4E-6F19-463E-8F3C-EAEC65F7FD03',
  approveEntries: '59B8AB4A-C69C-454D-B597-3DFA00A38608',
  myRequests: '53B8D265-1188-4A5B-BE63-60A5B3F092B1',
  waitingRequests: 'FE7054AE-03F0-497D-B498-E26056F82EA8'
}

const guid = {
  empty: AMSUITE_EMPTY_GUID
}

export { apps, widgets, guid };
